import angular from 'angular';
import ForgotPasswordComponent from './forgot-password-component';

export default angular
  .module('forgot-password', [])
  .component('forgotPassword', new ForgotPasswordComponent());



// WEBPACK FOOTER //
// ./src/modules/auth/components/forgot-password/forgot-password-module.js